import styled from 'styled-components';

/* ===== Page Background ===== */
const PageBackground = styled.section`
  background: #f5f7fa;
  padding: 24px 16px;
`;

/* ===== Card Container ===== */
const StyledFirmDetailsContainer = styled.section`
  max-width: 400px;
  margin: 0 0 24px 0;
  padding: 20px 24px;

  background: linear-gradient(145deg, #4676cf, #1a1f2c);
  border-radius: 14px;

  box-shadow:
    4px 4px 12px rgba(0, 0, 0, 0.08),
    -4px -4px 12px rgba(255, 255, 255, 0.9);
`;

/* ===== Content ===== */
const StyledContent = styled.div`
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  margin-bottom: 2px;

  strong {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    color: #010d12;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }
`;

const FirmDetailsCard = ({ data }) => {
    if (!data) return null;

    /* ===== GST & PAN Extraction ===== */
    const gstPanText = data.gstNumber || '';

    const gstMatch = gstPanText.match(/GST\s*NO-?\s*([A-Z0-9]+)/i);
    const panMatch = gstPanText.match(/PAN\s*NO-?\s*([A-Z0-9]+)/i);

    const gstNumber = gstMatch ? gstMatch[1] : '-';
    const panNumber = panMatch ? panMatch[1] : '-';

    return (
        <PageBackground>
            <StyledFirmDetailsContainer>

                <StyledContent>
                    <strong>Firm Name</strong>
                    {data.firmName}
                </StyledContent>

                <StyledContent>
                    <strong>GST Number</strong>
                    {gstNumber}
                </StyledContent>

                <StyledContent>
                    <strong>PAN Number</strong>
                    {panNumber}
                </StyledContent>

            </StyledFirmDetailsContainer>
        </PageBackground>
    );
};

export default FirmDetailsCard;